export default __webpack_public_path__ + "30271afe3927c5a74d30e5ffb74fe70a.png";